import React from "react";

const DEFAULT_PALETTE = {
  primary: "#2E6F40",
  mint: "#CFFFDC",
  mid: "#68BA7F",
  ink: "#253D2C",
};

export default function FAQSection({
  title = "Frequently Asked Questions",
  intro = "Quick answers to common questions about our process, fees, and communication.",
  faqs = [
    { q: "Do you offer an initial consultation?", a: "Yes — consultations are by appointment so we can prepare and respect your time. We confirm scope and next steps before any paid work begins." },
    { q: "How are fees quoted?", a: "We scope the matter and provide a transparent structure (fixed, capped, or hourly). You will always receive an estimate before we begin." },
    { q: "Do you work outside Delhi/NCR?", a: "Yes. We conduct online meetings and coordinate with trusted professionals across jurisdictions as required." },
    { q: "How will we share documents?", a: "We use secure file-sharing, e-signatures where permitted, and organised matter portals to keep everything on track." },
    { q: "What is your typical response time?", a: "We aim to acknowledge new client messages within the same business day and provide a substantive response or update within 24–48 hours." },
    { q: "Do you handle urgent or time-sensitive cases?", a: "Yes, urgent filings or time-barred matters are prioritised with a dedicated case manager to ensure compliance and timely execution." },
    {
        q: "What is your typical response time?",
        a: "We aim to acknowledge all client messages within the same business day and provide a substantive response or update within 24–48 hours.",
      },
      {
        q: "Do you handle urgent or time-sensitive cases?",
        a: "Yes — urgent filings and time-barred matters are prioritised with a dedicated case manager to ensure compliance and timely execution.",
      },
  ],
  palette = DEFAULT_PALETTE,
  onConsult = () => {
    try { document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); } catch {}
  },
}) {
  const COLORS = { ...DEFAULT_PALETTE, ...palette };

  return (
    <section className="relative py-14 md:py-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="mb-8 md:mb-10">
          <h2 className="text-3xl md:text-4xl font-semibold" style={{ color: COLORS.ink }}>{title}</h2>
          {intro && (
            <p className="mt-3 text-base md:text-lg max-w-3xl" style={{ color: COLORS.ink }}>
              {intro}
            </p>
          )}
        </header>

        {/* FAQ list - compact single column */}
<div className="space-y-3 md:space-y-4">
  {faqs.map((f, i) => (
    <details
      key={i}
      className="group rounded-lg border bg-white/90 p-3 md:p-4 transition-all duration-200 hover:shadow-sm"
      style={{ borderColor: COLORS.mid }}
    >
      <summary className="cursor-pointer list-none flex items-start justify-between gap-3">
        <span
          className="font-medium text-sm md:text-base"
          style={{ color: COLORS.ink }}
        >
          {f.q}
        </span>
        <span className="shrink-0 text-slate-600 group-open:rotate-45 transition-transform duration-200">
          +
        </span>
      </summary>
      <p
        className="mt-2 text-xs md:text-sm leading-relaxed"
        style={{ color: COLORS.ink }}
      >
        {f.a}
      </p>
    </details>
  ))}
</div>


        {/* CTA Bar */}
        <div className="mt-8 md:mt-12 rounded-2xl border p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" style={{ borderColor: COLORS.mid, background: `linear-gradient(0deg, #fff 0%, ${COLORS.mint}33 100%)` }}>
          <div>
            <div className="text-lg md:text-xl font-medium" style={{ color: COLORS.ink }}>Ready to talk through your matter?</div>
            <div className="text-sm md:text-base text-slate-700">We’ll scope your needs and outline next steps in plain English.</div>
          </div>
          <button
            onClick={onConsult}
            className="inline-flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-medium shadow-sm"
            style={{ background: COLORS.primary, color: '#fff' }}
          >
            Book a Consultation
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></svg>
          </button>
        </div>
      </div>
    </section>
  );
}